export default {
  title: 'Audit Trail',
  exportCsv: 'Export CSV',
  refresh: 'Refresh',
  startDateLabel: 'Start Date',
  endDateLabel: 'End Date',
  actionTypeLabel: 'Action Type',
  targetUserEmailLabel: 'Target User Email',
  viewChanges: 'View Changes',
  changeDetailsTitle: 'Change Details',
  actionLabel: 'Action:',
  performedByLabel: 'Performed By:',
  targetUserLabel: 'Target User:',
  modelIdLabel: 'Model ID:',
  timestampLabel: 'Timestamp:',
  changesTitle: 'Changes',
  beforeLabel: 'Before:',
  afterLabel: 'After:',
  headerTimestamp: 'Timestamp',
  headerAction: 'Action',
  headerPerformedBy: 'Performed By',
  headerTargetUser: 'Target User',
  headerModelId: 'Model ID',
  headerChanges: 'Changes',
  actionGrantAccess: 'Grant Access',
  actionRevokeAccess: 'Revoke Access',
  actionGrantReferenceAccess: 'Grant Reference Access',
  actionRevokeReferenceAccess: 'Revoke Reference Access',
  actionGrantEkrmAccess: 'Grant EKRM Access',
  actionRevokeEkrmAccess: 'Revoke EKRM Access',
  actionDeleteUser: 'Delete User',
  actionGrantGroupAccess: 'Grant Group Access',
  actionRevokeGroupAccess: 'Revoke Group Access',
  actionCreateGroup: 'Create Group',
  actionDeleteGroup: 'Delete Group',
  actionGrantGroupModelAccess: 'Grant Group Model Access',
  actionRevokeGroupModelAccess: 'Revoke Group Model Access',
  actionGrantGroupReferenceAccess: 'Grant Group Reference Access',
  actionRevokeGroupReferenceAccess: 'Revoke Group Reference Access',
  actionGrantGroupEkrmAccess: 'Grant Group EKRM Access',
  actionRevokeGroupEkrmAccess: 'Revoke Group EKRM Access',
  actionUnknown: 'Unknown Action',
  timestampNA: 'N/A',
  timestampInvalid: 'Invalid Date',
  exportSuccess: 'Audit logs exported successfully',
  exportError: 'Failed to export audit logs: ',
  loadError: 'Failed to load audit logs: ',
  indexErrorHint: ' Try clearing some filters to reduce the query complexity.'
}
